import { useState } from 'react'
import { IconButton, Tooltip } from '@mui/material'
import { Refresh as RefreshIcon } from '@mui/icons-material'

import { ActionConfirmDialog } from '@/apps/latest/components/molecules/ActionConfirmDialog'
import { colorTokens } from '@/apps/latest/shared/styles/colorTokens'

interface Props {
  onConfirm: () => void
  disabled?: boolean
  // 押せない理由。渡すと tooltip がこの 1 行になる (押せない間も理由が読める)
  disabledReason?: string
}

// 着地した報告書の作り直し (= 作る)。手で直した欄も置き換わるので確認を挟む。
// 置き場は名前の行の右端 (ダウンロードの左)。問診票・体組成・前回の持ち込みが会話の後に揃うことがある。
export const NutritionRegenerateButton = ({
  onConfirm,
  disabled,
  disabledReason,
}: Props) => {
  const [open, setOpen] = useState(false)
  return (
    <>
      <Tooltip title={disabledReason ?? '作り直す'}>
        <span>
          <IconButton
            size="small"
            aria-label="作り直す"
            onClick={() => setOpen(true)}
            disabled={disabled || Boolean(disabledReason)}
            sx={{ color: colorTokens.fg.muted }}
          >
            <RefreshIcon fontSize="small" />
          </IconButton>
        </span>
      </Tooltip>
      <ActionConfirmDialog
        open={open}
        title="報告書を作り直す"
        body="会話・メモ・添付資料から作り直します。手で直した欄も置き換わります (お客様の欄は残ります)。"
        actionLabel="作り直す"
        onClose={() => setOpen(false)}
        onConfirm={onConfirm}
      />
    </>
  )
}
